import { Navigate } from "react-router-dom";
import { useFeatureFlagsState } from "@/config/useFeatureFlags";

/**
 * Where "/" goes: the Operations dashboard for people who have it, the Requests screen otherwise.
 * Waits for the feature flags to arrive before deciding, so a user with Operations is never sent to
 * Requests by the all-off defaults during the first render; the wait is one small request and the
 * shell is already on screen.
 */
export function LandingRedirect() {
  const { flags, loaded } = useFeatureFlagsState();
  if (!loaded) return null;
  return <Navigate to={flags.operations ? "/operations" : "/requests"} replace />;
}
